import PropTypes from "prop-types";
import React from "react";

import { Section } from "@swa-ui/core";
import { CheckboxFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { PlacementInfoLabel } from "../PlacementInfoLabel";
import styles from "./AllergiesFormFields.module.scss";
import { ALLERGIES_SCHEMA_FIELD_NAMES } from "./AllergiesFormFields.schema";

const { PEANUT_ALLERGY } = ALLERGIES_SCHEMA_FIELD_NAMES;

export const AllergiesFormFields = (props) => {
  const { peanutAllergyFieldName = PEANUT_ALLERGY } = props;

  return (
    <Section {...getSectionProps()}>
      <CheckboxFormField {...getCheckboxFormFieldProps()} />
    </Section>
  );

  function getSectionProps() {
    return {
      headingProps: {
        bottomSpacing: "small",
        children: i18n("AllergiesFormFields__HEADER"),
        headingLevel: 2,
        styleLevel: 5,
        topSpacing: "medium",
      },
    };
  }

  function getCheckboxFormFieldProps() {
    return {
      className: styles.checkboxFormField,
      componentProps: {
        label: (
          <PlacementInfoLabel
            label="AllergiesFormFields__PEANUT_ALLERGY"
            placementId="disabilityOptionPeanut"
          />
        ),
      },
      hideBottomSection: true,
      name: peanutAllergyFieldName,
    };
  }
};

export const allergiesFormFieldsPropTypes = {
  /** Field name for peanut allergy assistance checkbox. */
  peanutAllergyFieldName: PropTypes.string,
};

AllergiesFormFields.propTypes = allergiesFormFieldsPropTypes;
